var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "popup-mark-phone-call-done",
      attrs: {
        visible: _vm.showModal,
        size: "small",
        title: _vm.$t.__("activities.popupMarkPoneCallDone.title")
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      [
        _vm.isLoading
          ? _c("compassLoader", {
              staticClass: "phonecall-mark-done--loading",
              attrs: { size: "large" }
            })
          : _c(
              "div",
              { staticClass: "phonecall-mark-done__content" },
              [
                _c("RichText", {
                  staticClass: "description-input-max-height",
                  attrs: {
                    formitem: {
                      label: _vm.$t.__("common.labels.note")
                    }
                  },
                  model: {
                    value: _vm.tempDescription,
                    callback: function($$v) {
                      _vm.tempDescription = $$v
                    },
                    expression: "tempDescription"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "container-result-duration" },
                  [
                    _c(
                      "CompassFormItem",
                      {
                        staticClass: "result",
                        attrs: {
                          label: _vm.$t.__(
                            "activities.popupMarkPoneCallDone.result"
                          )
                        }
                      },
                      [
                        _c(
                          "CompassSelect",
                          {
                            attrs: { menuClass: "select-result-phonecall" },
                            model: {
                              value: _vm.resultPhoneCall,
                              callback: function($$v) {
                                _vm.resultPhoneCall = $$v
                              },
                              expression: "resultPhoneCall"
                            }
                          },
                          _vm._l(_vm.resultOptions, function(result) {
                            return _c("CompassDropdownSelectOption", {
                              key: result.id,
                              attrs: { label: result.label, value: result.id }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "CompassFormItem",
                      {
                        attrs: {
                          label: _vm.$t.__(
                            "activities.popupMarkPoneCallDone.duration"
                          )
                        }
                      },
                      [
                        _c("DurationInput", {
                          attrs: { placeholder: "00:00:00" },
                          on: {
                            "update:value": function(value) {
                              return (_vm.durationInput = value)
                            }
                          },
                          model: {
                            value: _vm.durationInput,
                            callback: function($$v) {
                              _vm.durationInput = $$v
                            },
                            expression: "durationInput"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
      ],
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "phonecall-mark-done__footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("CompassButton", {
                attrs: {
                  type: "secondary",
                  label: _vm.$t.__("common.actions.cancel"),
                  disabled: _vm.isSubmitting
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              }),
              _vm._v(" "),
              _c("CompassButton", {
                attrs: {
                  loading: _vm.isSubmitting,
                  label: _vm.$t.__("common.actions.save")
                },
                on: { click: _vm.handleConfirm }
              })
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }